gsap.set('.archive-wrapper', {
    transform: "rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale3d(1,1,1)",
    opacity: 1,
})
gsap.set('.row-div-3', {
    x: 0,
    y: "-8.0032%",
    z: 0,
})
gsap.set('.row-div-1', {
    x: 0,
    y: "-4.80192%",
    z: 0,
})
gsap.set('.row-div-2', {
    x: 0,
    y: "-6.40256%",
    z: 0,
})
gsap.set('.archive-title-wrapper', {
    opacity: 0,
})

const at = gsap.timeline({
    scrollTrigger: {
        trigger: ".archive-trigger",
        start: "top top",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})

at
    .to('.archive-wrapper', {
        transform: "rotateX(0deg) rotateY(0deg) rotateZ(-19.1432deg) scale3d(0.617136,0.617136,1)",
        opacity: 0.06,
    }, 'aa')
    .to('.row-div-3', {
        x: 0,
        y: "-38.7148%",
        z: 0,
    }, 'aa')
    .to('.row-div-1', {
        x: 0,
        y: "-23.2289%",
        z: 0,
    }, 'aa')
    .to('.row-div-2', {
        x: 0,
        y: "-30.9718%",
        z: 0,
    }, 'aa')
    .to('.archive-title-wrapper', {
        opacity: 1,
    }, 'aa')